"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const constants_1 = __importStar(require("../utils/constants"));
const _base_1 = require("./_base");
/**
 * ![DotMenuHorizontalIcon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMyAzIiBoZWlnaHQ9IjMwIiB3aWR0aD0iMzAiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGZpbGw6ICNmZmY7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDx0aXRsZT5Eb3RNZW51SG9yaXpvbnRhbDwvdGl0bGU+CiAgPGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+CiAgICA8ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPgogICAgICA8Y2lyY2xlIGNsYXNzPSJjbHMtMSIgY3g9IjEuNSIgY3k9IjEuNSIgcj0iMS41Ii8+CiAgICAgIDxjaXJjbGUgY2xhc3M9ImNscy0xIiBjeD0iNi41IiBjeT0iMS41IiByPSIxLjUiLz4KICAgICAgPGNpcmNsZSBjbGFzcz0iY2xzLTEiIGN4PSIxMS41IiBjeT0iMS41IiByPSIxLjUiLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=)
 */
exports.DotMenuHorizontalIcon = (_a) => {
    var { size = 18, color } = _a, props = __rest(_a, ["size", "color"]);
    const iconColor = constants_1.expandColor(constants_1.default, color) || "currentColor";
    return (React.createElement(_base_1.Svg, Object.assign({ viewBox: "0 0 13 3", fill: iconColor, width: size, height: size, size: size, role: props.onClick ? "button" : undefined, tabIndex: props.onClick ? 0 : undefined }, props),
        React.createElement("circle", { cx: 1.5, cy: 1.5, r: 1.5 }),
        React.createElement("circle", { cx: 6.5, cy: 1.5, r: 1.5 }),
        React.createElement("circle", { cx: 11.5, cy: 1.5, r: 1.5 })));
};
//# sourceMappingURL=Icon.DotMenuHorizontal.js.map